export const hasAnyKey = (obj: object) => {
  return Object.keys(obj).length > 0
}
